import _implicitStylesheets from "./errorModal.css";

import _implicitScopedStylesheets from "./errorModal.scoped.css?scoped=true";

import _lightningDatatable from "lightning/datatable";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, d: api_dynamic_text, t: api_text, h: api_element, c: api_custom_element, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [$cmp.isModalOpen ? api_element("div", {
    key: 0
  }, [api_element("section", {
    classMap: {
      "slds-modal": true,
      "slds-fade-in-open": true,
      "slds-modal_large": true
    },
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-02"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-2")
    },
    key: 1
  }, [api_element("div", {
    classMap: {
      "slds-modal__container": true,
      "fitler-modal_div": true,
      "migrate-modal_align": true
    },
    key: 2
  }, [api_element("header", {
    classMap: {
      "slds-modal__header": true
    },
    key: 3
  }, [api_element("h2", {
    classMap: {
      "slds-modal__title": true,
      "slds-hyphenate": true
    },
    attrs: {
      "id": api_scoped_id("modal-heading-02")
    },
    key: 4
  }, [api_text(api_dynamic_text($cmp.modalTitle))]), api_element("br", {
    key: 5
  }, []), api_element("p", {
    classMap: {
      "slds-m-top_x-small": true
    },
    key: 6
  }, [api_text("These items will not be deployed to the destination org")])]), api_element("div", {
    classMap: {
      "slds-modal__content": true,
      "slds-p-around_medium": true,
      "slds_migrate-status": true,
      "error-modal_size": true
    },
    attrs: {
      "id": api_scoped_id("modal-content-id-2")
    },
    key: 7
  }, [api_custom_element("lightning-datatable", _lightningDatatable, {
    classMap: {
      "error-data-table_size": true
    },
    props: {
      "keyField": "id",
      "data": $cmp.migrateStatusData,
      "columns": $cmp.columns,
      "hideCheckboxColumn": true
    },
    key: 8
  }, [])]), api_element("footer", {
    classMap: {
      "slds-modal__footer": true,
      "error-modal-footer_alignment": true
    },
    key: 9
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_brand": true,
      "error-modal-button_pos": true
    },
    key: 10,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.closeModal))
    }
  }, [api_text("OK")])])])]), api_element("div", {
    classMap: {
      "slds-backdrop": true,
      "slds-backdrop_open": true
    },
    key: 11
  }, [])]) : null];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-errorModal_errorModal"
